import React from 'react'
import PropTypes from 'prop-types'
import { Typography, Stack } from '@mui/material_modern'
import RegradeSummaryInformationRow from 'components/containers/inventory/regrades/RegradeSummaryInformationRow'

// materials are the regrade materials
const RegradeSummaryInformation = ({ materials, effectiveDate, costOfMaterial, fromQuantity, tosQuantity }) => (
  <Stack mt={1} spacing={1}>
    <Typography variant="h6">Summary Information</Typography>
    <Stack>
      {materials.map(material => (
        <React.Fragment key={material.id}>
          <RegradeSummaryInformationRow
            material={material}
            effectiveDate={effectiveDate}
            costOfMaterial={costOfMaterial}
            fromQuantity={fromQuantity}
            tosQuantity={tosQuantity}
          />
        </React.Fragment>
      ))}
    </Stack>
  </Stack>
)

RegradeSummaryInformation.propTypes = {
  materials: PropTypes.array,
  effectiveDate: PropTypes.string,
  costOfMaterial: PropTypes.number,
  fromQuantity: PropTypes.number,
  tosQuantity: PropTypes.number,
}

RegradeSummaryInformation.defaultProps = {
  materials: [],
  effectiveDate: '',
  costOfMaterial: 0,
  fromQuantity: 0,
  tosQuantity: 0,
}

export default RegradeSummaryInformation
